import { RAW_COLORS } from '../colors';

export const DIMMED_THEME = {
  color: {
    default: RAW_COLORS.blackAlpha50,
  },
};